// sessionStorage throws SecurityError in WebViews and browsers with storage blocked.
// All access goes through this wrapper so a blocked storage never crashes the app.
export const safeSessionStorage = {
  getItem: (key: string): string | null => {
    try { return sessionStorage.getItem(key) } catch { return null }
  },
  setItem: (key: string, value: string): void => {
    try { sessionStorage.setItem(key, value) } catch { /* storage blocked */ }
  },
  removeItem: (key: string): void => {
    try { sessionStorage.removeItem(key) } catch { /* storage blocked */ }
  },
}
